/**
 * Terms Service (ATR-563) — cliente de `POST /terms/accept` e
 * `POST /terms/decline`, endpoints entregues pelo backend em ATR-562.
 *
 * Não há GET: o estado corrente vem no bloco `terms` de `GET /auth/me`.
 * A versão é sempre explícita no body — o backend recusa versão divergente da
 * vigente com 400 `VALIDATION_TERMS_VERSION_MISMATCH` em vez de registrar o
 * aceite de um texto que o usuário não viu (aba velha aberta durante uma
 * revisão dos termos).
 */

import { api } from '@/services/api';
import type { TermsStatus } from '@/types/auth.types';

export const termsService = {
  async accept(version: string): Promise<TermsStatus> {
    const { data } = await api.post<TermsStatus>('/terms/accept', { version });
    return data;
  },

  async decline(version: string): Promise<TermsStatus> {
    const { data } = await api.post<TermsStatus>('/terms/decline', { version });
    return data;
  },
};
